import { MoreOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import CustomPopover from '../../components/shared/custompopover/CustomPopover';
import LottieIcon from '../../components/shared/lottieIcon/LottieIcon';
import viewIcon from "../../assets/icons/Eye.svg";
import deleteIcon from "../../assets/icons/Delete.svg";
import { Ellipsis } from 'lucide-react';
import optionsIcon from "../../assets/icons/Options.svg"




export const AddBundleFields = (
    filteredCourses
) => [
        {
            section: "Add Bundle",
            name: "bundleName",
            label: "Curriculum Name",
            type: "text",
            placeholder: "Curriculum Name",
            required: true,
        },
        {
            section: "Add Bundle",
            name: "courses",
            label: "Select Courses",
            type: "multi-select",
            maxTagCount: "1",
            options: filteredCourses || [],
            placeholder: "Select Courses",
            required: true,
        },

    ]

export const CurriculumHistoryColumns = (visiblePopover,
    setVisiblePopover,
    hoveredButton,
    setHoveredButton,
    handleOpenConfirmDeletePopup,
    handleViewUserClick) => [

        {
            title: 'Course Name',
            dataIndex: 'name',
            key: 'name',
            width: "60.33%",
            onCell: () => ({ className: "table-cell-padded" }),
            onHeaderCell: () => ({ className: "table-cell-padded" }),
            render: (text) => (
                <div className="description-cell" title={text}>
                    {text || "N/A"}
                </div>
            ),
        },
        {
            title: 'Level',
            dataIndex: 'level',
            key: 'level',
            width: "60.33%",
            onCell: () => ({ className: "table-cell-padded" }),
            onHeaderCell: () => ({ className: "table-cell-padded" }),
        },
        {
            title: "Action",
            key: "actions",
            width: "20.33%",
            align: "center",
            onCell: () => ({ className: "table-cell-padded" }),
            onHeaderCell: () => ({ className: "table-cell-padded" }),
            render: (text, record) => {
                const popoverContent = (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                        }}
                    >
                        <Button
                            className="navbar-item"
                            onClick={() => {
                                handleViewUserClick(record?.id, record?.name);
                                setVisiblePopover(null)
                            }}
                            onMouseEnter={() => setHoveredButton("view")}
                            onMouseLeave={() => setHoveredButton(null)}
                            style={{ width: "11rem" }}
                        >
                            <span>View</span>
                            {hoveredButton === "view" ? (
                                <LottieIcon name="viewIcon" size={28} shouldPlay={true} />
                            ) : (
                                <img src={viewIcon} alt="view-icon" height={28} />
                            )}
                        </Button>

                        <Button
                            onClick={() => {
                                handleOpenConfirmDeletePopup(record);
                                setVisiblePopover(null);
                            }}
                            style={{ width: "11rem" }}
                            className="navbar-item"
                            onMouseEnter={() => setHoveredButton("delete")}
                            onMouseLeave={() => setHoveredButton(null)}
                        >
                            <span>Delete</span>
                            {hoveredButton === "delete" ? (
                                <LottieIcon name="trashIcon" size={24} shouldPlay={true} />
                            ) : (
                                <img src={deleteIcon} alt="delete-icon" height={28} />
                            )}
                        </Button>
                    </div>
                );

                return (
                    <CustomPopover
                        content={popoverContent}
                        trigger="click"
                        className="admin-popover"
                        placement="bottomRight"
                        visible={visiblePopover === record.id}
                        onVisibleChange={(visible) => {
                            setVisiblePopover(visible ? record.id : null);
                            if (!visible) setHoveredButton(null);
                        }}
                        getPopupContainer={() => document.body}
                    >
                        <img src={optionsIcon} alt="options-icon" height={24} />
                    </CustomPopover>
                );
            },
        },
    ];


export const CurriculumReportColumns = (handleViewBundleClick) => [

    {
        title: "Curriculum Name",
        dataIndex: "bundleName",
        key: "bundleName",
        width: 180,
        render: (text) => (
            <span
            >
                {text}
            </span>

        ),
    },

    {
        title: "Unique Enrollees",
        dataIndex: "uniqueEnrollees",
        key: "uniqueEnrollees",
        width: 180,
    },
    {
        title: "Assigned Courses",
        dataIndex: "uniqueAssignedCourses",
        key: "uniqueAssignedCourses",
        width: 150,
    },
    {
        title: "Unique Enrollments",
        dataIndex: "uniqueEnrollments",
        key: "uniqueEnrollments",
        width: 150,
    },
    {
        title: "Completed Enrollments",
        dataIndex: "completedEnrollments",
        key: "completedEnrollments",
        width: 160,
    },
    {
        title: "In progress Enrollments",
        dataIndex: "inProgressEnrollments",
        key: "inProgressEnrollments",
        width: 160,
    },
    {
        title: "Not Started Enrollments",
        dataIndex: "notStartedEnrollments",
        key: "notStartedEnrollments",
        width: 170,
    },
    {
        title: "On Time Completed Enrollments",
        dataIndex: "onTimeCompletedEnrollments",
        key: "onTimeCompletedEnrollments",
        width: 180,
    },
    {
        title: "Late Completed Enrollments",
        dataIndex: "lateCompletedEnrollments",
        key: "lateCompletedEnrollments",
        width: 170,
    },
    {
        title: "On Track Enrollments",
        dataIndex: "onTrackEnrollments",
        key: "onTrackEnrollments",
        width: 160,
    },
    {
        title: "Behind Schedule Enrollments",
        dataIndex: "behindScheduleEnrollments",
        key: "behindScheduleEnrollments",
        width: 190,
    },
    {
        title: "Not Due Yet Enrollments",
        dataIndex: "notDueYetEnrollments",
        key: "notDueYetEnrollments",
        width: 170,
    },
    {
        title: "No deadline enollments",
        dataIndex: "noDeadlineEnrollments",
        key: "noDeadlineEnrollments",
        width: 160,
    },
];
